"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalReviewListPageResponseSchema = void 0;
var zod_1 = require("zod");
var sort_option_1 = require("../sort-option");
exports.GlobalReviewListPageResponseSchema = zod_1.z.object({
    resources: zod_1.z.object({
        propertyId: zod_1.z.string(),
    }),
    query: zod_1.z.object({
        page: zod_1.z.number().optional(),
        sort: zod_1.z
            .union([
            zod_1.z.literal(sort_option_1.GLOBAL_SORT_OPTION.LANGUAGE_DESC.code),
            zod_1.z.literal(sort_option_1.GLOBAL_SORT_OPTION.REVIEWED_AT_DESC.code),
            zod_1.z.literal(sort_option_1.GLOBAL_SORT_OPTION.SCORE_DESC.code),
            zod_1.z.literal(sort_option_1.GLOBAL_SORT_OPTION.SCORE_ASC.code),
        ])
            .optional(),
    }),
});
